export const SUBMIT_MOOD_METER_INGROUP_PLOT = 'SUBMIT_MOOD_METER_INGROUP_PLOT'
export const CHANGE_MOOD_METER_INGROUP_FORM_FIELD = 'CHANGE_MOOD_METER_INGROUP_FORM_FIELD'
export const ADD_MOOD_METER_INGROUP_FIELDS_ERRORS = 'ADD_MOOD_METER_INGROUP_FIELDS_ERRORS'
export const RESET_MOOD_METER_INGROUP_FORM_DATA = 'RESET_MOOD_METER_INGROUP_FORM_DATA'
export const CLEAR_MOOD_METER_INGROUP_FIELD_ERROR = 'CLEAR_MOOD_METER_INGROUP_FIELD_ERROR'

interface ChangeMoodMeterInGroupFormFieldAction {
  type: typeof CHANGE_MOOD_METER_INGROUP_FORM_FIELD
  payload: {
    key: string
    value: string
  }
}

interface ResetMoodMeterInGroupFormDataAction {
  type: typeof RESET_MOOD_METER_INGROUP_FORM_DATA
}

interface AddFieldsErrorsAction {
  type: typeof ADD_MOOD_METER_INGROUP_FIELDS_ERRORS
  payload: {
    errors: Record<string, string>
  }
}

interface ClearFieldErrorAction {
  type: typeof CLEAR_MOOD_METER_INGROUP_FIELD_ERROR
  payload: {
    field: string
  }
}

export type InGroupActionTypes =
  | ChangeMoodMeterInGroupFormFieldAction
  | ResetMoodMeterInGroupFormDataAction
  | AddFieldsErrorsAction
  | ClearFieldErrorAction

export function changeMoodMeterInGroupFormField(
  key: string,
  value: string,
): ChangeMoodMeterInGroupFormFieldAction {
  return {
    type: CHANGE_MOOD_METER_INGROUP_FORM_FIELD,
    payload: {
      key,
      value,
    },
  }
}

export function resetMoodMeterInGroupFormData(): ResetMoodMeterInGroupFormDataAction {
  return {
    type: RESET_MOOD_METER_INGROUP_FORM_DATA,
  }
}

export function addFieldsErrors(errors: Record<string, string>): AddFieldsErrorsAction {
  return {
    type: ADD_MOOD_METER_INGROUP_FIELDS_ERRORS,
    payload: {
      errors,
    },
  }
}

export function clearFieldError(field: string): ClearFieldErrorAction {
  return {
    type: CLEAR_MOOD_METER_INGROUP_FIELD_ERROR,
    payload: {
      field,
    },
  }
}
